import angular from 'angular';
import ModalConfirmationSaveItemsComponent from './modal-confirmation-save-items.component';

let ModalConfirmationSaveItemsModule = angular.module('catalog.modalConfirmationSaveItems', [])
  .component('modalConfirmationSaveItems', ModalConfirmationSaveItemsComponent);

export default ModalConfirmationSaveItemsModule;













/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/modal-confirmation-save-items/modal-confirmation-save-items.js
 **/